//import customer from "./customer";
//import vmCustomerOrder from "./vmCustomerOrder";

class vmOrderDetail {
  orderDetailID_GUID: number;
  entyOrView: number = 3;
  indexNo: number;
  productItemGUID: string;
  productItem: any;
  settingsID_GUID: string;
  qty: number;
  lstMeasurementDetails: any[] = [];
  // constructor() {
  //   this.listMeasurementDetails = [];
  // }
}

export default vmOrderDetail;
